<div *ngIf="toggled && isMobile" class="jmCollapseTitleLearnMore">
	<div class="jmPageTitle" style="padding-top: 10px;">
		Interest Survey <span *ngIf="surveyCompleted">Results</span>
		<div class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-plus-square" role="button" (click)="toggleCollapse()"></div>
	</div>
</div>

<div *ngIf="!toggled && retrievingData" class="d-flex align-items-center justify-content-center w-100 h-100">
	<span class="jmWidgetLoadingIcon40"></span>
</div>

<!--default state user sees before having taken interest survey-->
<div *ngIf="!retrievingData && !toggled && !surveyCompleted && !showMore" class="h-100 jmWidgetPadding bg-white">
	<div *ngIf="isMobile" class="jmPageTitle">
		Interest Survey Results
		<div role="button" (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square"></div>
	</div>

	<div style="display: flex; flex-direction: column; position: relative;" class="w-100 text-center" [ngStyle]="isMobile? {'height':'325px' }:{'height':'100%'}">
		<div *ngIf="!isMobile" class="jmPageTitle text-start">Interest Survey</div>
		<div *ngIf="!isMobile" style="position: absolute; right: 0; font-size: 25px; color: var(--bs-primary); pointer-events: all;" role="button" (click)="toggleShowMore()" class="fas fa-ellipsis-v"></div>

		<div style="display: flex; align-items: center; flex-direction: column; padding: 10px 0 10px 0;">
			<img src="assets/images/splash_interest_survey.png" class="circleImageScale"/>
		</div>
		<div style="margin-bottom: auto; overflow-y: auto;">Let your interests match you with career recommendations that fit you. Take 10 minutes to see your result today!</div>
		<div style="display: flex; flex-direction: column;">
			<button style="align-self: flex-start; margin-left: auto; margin-right: auto;" class="btn btn-primary" (click)="startSurvey($event)">Start Survey</button>
			<img src="assets/images/blank.png" style="height: 15px; width: auto; align-self: flex-start; margin-left: auto; margin-right: auto; margin-top: 5px;" />
		</div>
	</div>
</div>

<!--state user sees when 'more' view is toggled on-->
<div *ngIf="!retrievingData && !toggled && !surveyCompleted && showMore" class="h-100 jmWidgetPadding bg-white">
	<table class="w-100 text-center" [ngStyle]="{'height':isMobile?'325px':'100%'}">
		<tr *ngIf="!isMobile" style="height: 50px;">
			<td style="vertical-align:top;" class="jmPageTitle text-start">
				Interest Survey
				<div class="float-end"><button type="button" class="jmCloseBtn" (click)="toggleShowMore()"></button></div>
			</td>
		</tr>
		<tr>
			<td style="display: flex; flex-direction: column; align-items: center;">
				<div (click)="editScores($event, true)"  role="button" class="text-primary" style="display: flex; align-items: center;" >
					<div style="width: 40px; padding-right: 10px; display: inline;">
						<i class="icnPencil" role="button" style="font-size: 25px;"></i>
					</div>
					<div style="font-size: 14px; font-weight: 400; display: inline;">Manually Enter RIASEC</div>
				</div>
			</td>
		</tr>
	</table>
</div>

<div *ngIf="!retrievingData && surveyCompleted && !toggled" class="h-100 jmWidgetPadding bg-white">
	<div class="h-100" style="display: flex; flex-direction: column; ">
		<div class="jmPageTitle">
			Interest Survey Results
			<div *ngIf="isMobile" (click)="toggleCollapse()" class="jmWidgetControlContainer jmWidgetRightControlContainer fa fa-minus-square" style="margin-top:10px;"></div>
		</div>

		<div *ngIf="RIASECObjs==null" style="text-align: center;">
			No results found. Please <a href="javascript:void" (click)="startSurvey($event)">take the interest survey</a> first.
		</div>

		<div *ngFor="let result of (RIASECObjs? RIASECObjs.slice(0,3):[]); let i=index;" style="display: flex; flex-direction: column; flex: 1; min-height: 0; margin-bottom: 10px;" [ngClass]="(i > 0)?'surveyResultSpacing':'surveyResultSpacingTop'">
			<div style="display: flex; justify-content: space-between;">
				<div style="display: flex; align-content: center;">
					<div>
						<i class="{{result.iconFont}}" style="font-size: 25px; color: var(--bs-secondary); padding-right: 10px;"></i>
					</div>
					<div style="font-weight: 700;">
						{{result.label}}  ({{result.value}})
					</div>
				</div>
				<div class="text-primary" style="line-height: 28px; display: inline; float: right;" role="button" (click)="readMore(result)">
					Read More
				</div>
			</div>
			<div class="surveyResultFullText">
				<div class="surveyResultTruncateText">{{result.description}}</div>
			</div>
		</div>

		<div *ngIf="RIASECObjs!=null" style="display: flex; align-items: center; justify-content: space-around; background-color: #f0f0f0; padding: 10px 0 5px 0; margin-top: 10px;">
			<div role="button" (click)="surveyResult($event)" style="display: flex; flex-direction: column; align-items: center;">
				<i class="text-primary icnChartBar" ngbTooltip="{{tooltipValues.results}}" placement="bottom" style="font-size: 25px; border-radius: 3px; padding: 0 6px 0 6px; line-height: 1.5;"></i>
				<div style="color: #95A5A6;">Results</div>
			</div>

			<div role="button" (click)="editScores($event, false)" style="display: flex; flex-direction: column; align-items: center;">
				<i class="text-primary icnPencil" ngbTooltip="{{tooltipValues.edit}}" placement="bottom" style="font-size: 25px; line-height: 1.5;"></i>
				<div style="color: #95A5A6;">Edit</div>
			</div>

			<div role="button" (click)="startSurvey($event)" style="display: flex; flex-direction: column; align-items: center; pointer-events: all; cursor: pointer;">
				<i class="text-primary icnListCheck" ngbTooltip="{{tooltipValues.retake}}" placement="bottom" style="font-size: 25px; line-height: 1.5;"></i>
				<div style="color: #95A5A6;">Retake</div>
			</div>
		</div>
	</div>
</div>
